import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/ubuntu/download_production/69eda13c63911b00146e8320/vidalivre/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/home/ubuntu/download_production/69eda13c63911b00146e8320/vidalivre/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69eda13c63911b00146e8320/vidalivre/src/styles/tailwind.css");
